<template>
  <div class="wrap">
    <div class="container">
      <div class="order_completed">
        <div class="order_page">주문 완료</div>
        <div class="order_res">
          <!-- <div class="img">
            <img src="/assets/images/layout/complete_2.png" />
          </div> -->
          <div class="txt">주문이 <span>완료</span>되었습니다.</div>
        </div>
        <div class="order_info">
          <div class="nl">
            <div>주문 번호</div>
            <div class="f_13" v-html="completDatas.orderNum"></div>
            <!-- <div class="f_13">0000-0000-0000-0000</div> -->
          </div>

          <div class="nl">
            <div>주문 내역</div>
            <div>
              <!-- 콘텐츠 | <span v-html="completDatas.contentsTitle"></span> -->
              <!-- <br /> -->
              <!-- <div v-if="setOptions">
                <span v-for="(option, index) in setOptions" :key="index">
                  <span
                    v-html="
                      index + 1 + ') ' + option.name + ' ' + option.count + '개'
                    "
                  ></span
                  ><br />
                </span>
              </div> -->
              <div v-if="setOptions" class="options-container">
                <div
                  v-for="(option, index) in setOptions"
                  :key="index"
                  class="option-row f_13"
                >
                  <span class="option-label">
                    <span v-if="option.name.includes('구독권')">콘텐츠</span>
                    <span v-else>추가 옵션</span>
                  </span>
                  <span class="option-detail">
                    <span v-if="option.name.includes('구독권')">
                      {{ completDatas.contentsTitle }} -
                      {{ option.name.split(' ')[0] }}
                    </span>
                    <span v-else>{{ option.name }} {{ option.count }}개</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div v-if="payMethodText === '신용카드'" class="nl">
            <div>결제 수단</div>
            <div>
              <span v-html="payMethodText"></span><br />
              <!-- <span>신용카드</span><br /> -->
              <br />
              <span v-html="resValue1 + ' ' + resValue2"></span><br />
              <!-- <span>라온카드 0000-0000-0000</span><br /> -->
              <div v-if="resValue3 === '일시불' || resValue3 === ''">
                <span>일시불</span><br />
              </div>
              <div v-else>할부개월: <span v-html="resValue3"></span></div>
              승인일시:
              <span
                v-html="
                  appTime.slice(0, 4) +
                  '년' +
                  appTime.slice(4, 6) +
                  '월' +
                  appTime.slice(6, 8) +
                  '일 ' +
                  appTime.slice(8, 10) +
                  ':' +
                  appTime.slice(10, 12) +
                  ':' +
                  appTime.slice(12, 14)
                "
              ></span>
              <!-- 승인일시: <span>2024.11.11</span> -->
            </div>
          </div>
          <div v-if="payMethodText === '계좌이체'" class="nl">
            <div>결제 수단</div>
            <div>
              <span v-html="payMethodText"></span><br />
              <!-- <span>계좌이체</span><br /> -->
              <br />
              예금주: <span>라온메타뱅크 0000-0000-0000 라온메타</span><br />
              승인일시:
              <span
                v-html="
                  appTime.slice(0, 4) +
                  '년' +
                  appTime.slice(4, 6) +
                  '월' +
                  appTime.slice(6, 8) +
                  '일 ' +
                  appTime.slice(8, 10) +
                  ':' +
                  appTime.slice(10, 12) +
                  ':' +
                  appTime.slice(12, 14)
                "
              ></span>
            </div>
          </div>
          <div v-if="payMethodText === '가상계좌'" class="nl">
            <div>결제 수단</div>
            <div>
              <span v-html="payMethodText"></span><br /><br />
              입금은행: <span v-html="resValue1"></span><br />
              예금주: <span v-html="resValue2"></span><br />
              계좌번호: <span v-html="resValue3"></span><br />
              입금마감시간: <span v-html="formattedDate"> </span><br /><br />
              <span>
                [가상계좌]로 결제 시 안내되는 입금기한 내에 입금처리가 되어야
                주문 접수가 완료됩니다.
              </span>
              <p>* 미입금 시 주문취소처리 및 가상계좌번호가 소멸됩니다.</p>
            </div>
          </div>

          <!-- <div class="nl">
            <div>결제 수단</div>
            <div>
              <span>신용카드</span><br />
              <br />
              <span>라온카드 0000-0000-0000</span><br />
              <span>일시불</span><br />
              승인일시: <span>2024.11.11</span>
            </div>
          </div> -->

          <div class="nl">
            <div>결제 금액</div>
            <div
              class="f_13"
              v-html="completDatas.totalCostAmt.toLocaleString() + ' 원'"
            ></div>
          </div>
        </div>

        <div class="order_btn">
          <div class="btns" @click="moveToUrl('/')">메인 페이지로</div>
          <div class="btns" @click="moveToUrl('/order_list')">구매내역</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter, onBeforeRouteLeave } from 'vue-router'
import { ref, onMounted } from 'vue'

export default {
  name: 'OrderCompleted',
  components: {
    //
  },
  setup() {
    const router = useRouter()

    const storageDatas = localStorage.getItem('orderCompletedData')
    const completDatas = JSON.parse(storageDatas)
    const getOptionsIdxs = completDatas.optionsIdxs
    const getOptionsName = completDatas.optionsNames
    const getOptionsCnts = completDatas.optionsCnts
    const setOptions = Array.isArray(getOptionsIdxs)
      ? getOptionsIdxs.map((idx, i) => ({
          idx: idx,
          name: getOptionsName[i],
          count: getOptionsCnts[i],
        }))
      : []

    // const setOptions = getOptionsIdxs.map((idx, i) => ({
    //   // eslint-disable-next-line object-shorthand
    //   idx: idx,
    //   name: getOptionsName[i],
    //   count: getOptionsCnts[i],
    // }))
    // console.log('getOptionsIdxs') // 배열이 아니라면 여기서 확인 가능
    // console.log(getOptionsIdxs) // 배열이 아니라면 여기서 확인 가능
    // console.log(Array.isArray(getOptionsIdxs)) // true여야 정상
    const payMethodText = ref('')
    const getPayMet = completDatas.pgPayMethod
    switch (getPayMet) {
      case '100000000000':
        payMethodText.value = '신용카드'
        break
      case '010000000000':
        payMethodText.value = '계좌이체'
        break
      case '001000000000':
        payMethodText.value = '가상계좌'
        break
      default:
        payMethodText.value = '결제에러'
        break
    }

    const resValue1 = ref('')
    const resValue2 = ref('')
    const resValue3 = ref('')
    const resValue4 = ref('')
    const appTime = ref('')
    const formattedDate = ref('')

    const settingPayResult = () => {
      resValue1.value = completDatas.resValue1
      resValue2.value = completDatas.resValue2
      resValue3.value = completDatas.resValue3
      resValue4.value = completDatas.resValue4
      appTime.value = completDatas.appTime
      resValue4.value = completDatas.resValue4
      if (resValue4.value !== null) {
        const year = resValue4.value.slice(0, 4)
        const month = resValue4.value.slice(4, 6)
        const day = resValue4.value.slice(6, 8)
        const hour = resValue4.value.slice(8, 10)
        const minute = resValue4.value.slice(10, 12)
        const second = resValue4.value.slice(12, 14)
        formattedDate.value = `${year}-${month}-${day} ${hour}:${minute}:${second}`
      }
    }
    const moveToUrl = (url) => {
      // window.location.href = url
      router.push({ path: url })
    }
    onMounted(() => {
      settingPayResult()
      // localStorage.removeItem('orderData')
    })
    // onBeforeRouteLeave 훅을 사용, 페이지를 떠나기 전 실행될 로직을 여기에 넣어준다.
    onBeforeRouteLeave((to, from, next) => {
      // orderCompletedData라는 localStorage에 저장된 값을 삭제한다.
      // localStorage.removeItem('orderCompletedData')
      // 혹시 모르니 localStorage에 저장된 값을 다 삭제하는 코드 추가
      // localStorage.clear()
      next()
    })
    return {
      moveToUrl,
      completDatas,
      setOptions,
      payMethodText,
      resValue1,
      resValue2,
      resValue3,
      resValue4,
      appTime,
      formattedDate,
    }
  },
}
</script>

<style></style>
